/**
 * Guarda o rótulo do contato escolhido no filtro (nome — e-mail) fora da URL.
 *
 * O filtro em si é o `userId`, um id opaco; o rótulo existe só para o operador
 * ver quem escolheu. Enquanto ele viajava junto no query string, o nome e o
 * e-mail de um cliente entravam no endereço da página — e portanto no
 * histórico do navegador, no `Referer` de qualquer recurso externo e em todo
 * link colado num chat ou ticket. `sessionStorage` mantém a mesma
 * conveniência (o rótulo sobrevive a recarregar e a navegar de volta) sem
 * espalhar o dado por esses canais, e morre com a aba.
 *
 * Cache, não fonte de verdade: sem entrada, a UI mostra o próprio `userId`.
 * Só o rótulo cai — o filtro continua aplicado, porque quem filtra é o id.
 */
const KEY_PREFIX = 'contact-label:';

export function rememberContactLabel(userId: string, label: string): void {
  try {
    sessionStorage.setItem(`${KEY_PREFIX}${userId}`, label);
  } catch {
    /* modo privado / storage cheio: seguir sem cache é aceitável */
  }
}

export function recallContactLabel(userId: string): string | null {
  try {
    return sessionStorage.getItem(`${KEY_PREFIX}${userId}`);
  } catch {
    return null;
  }
}
